<div class="response-container">
	<div class="titleContainer">
		<h2>Tobacco: Units Sold vs. Amount Spent</h2>
	</div>
	<div class="infoContainer">
		<div class="chart">
			<canvas baseChart [data]="barChartData" [options]="barChartOptions" [type]="barChartType"></canvas>
		</div>
		<div class="table-container">
			<table class="analytics-table">
				<thead>
					<tr>
						<th>Tobacco Name</th>
						<th>Total Bought</th>
						<th>Total Spent</th>
						<th>Locations</th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let item of tobaccoData; let i = index">
						<td>{{ item.tobacco_name }}</td>
						<td>{{ item.total_bought | abs }}</td>
						<td>{{ item.total_spent !== null ? item.total_spent.toLocaleString('en-US') : 'N/A' }}</td>
						<td>{{ item.locations }}</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
	<div *ngIf="formLoading" class="loading-overlay">Loading...</div>
</div>
